import React, { JSX } from "react";
import { DashboardStat } from "../mockData";

const statIcons: Record<string, JSX.Element> = {
  "Total Complaints": (
    <svg
      className="w-6 h-6 text-blue-600"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 7h18M3 12h18M3 17h18"
      />
    </svg>
  ),
  "Feedback Submitted": (
    <svg
      className="w-6 h-6 text-amber-500"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8a9 9 0 1118 0z"
      />
    </svg>
  ),
  "Appeals Filed": (
    <svg
      className="w-6 h-6 text-emerald-600"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  ),
  "Active Users": (
    <svg
      className="w-6 h-6 text-cyan-600"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="7" r="4" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.5 21a7.5 7.5 0 0113 0"
      />
    </svg>
  ),
};

type Props = {
  stats: DashboardStat[];
};

const DashboardStatCards: React.FC<Props> = ({ stats }) => {
  const getAccentColor = (accent: string) => {
    // Extract color from tailwind class like "from-blue-500"
    const match = accent.match(/from-([a-z]+)-\d+/);
    if (match) {
      const colorMap: Record<string, string> = {
        blue: "#3b82f6",
        amber: "#f59e0b",
        emerald: "#10b981",
        cyan: "#06b6d4",
        rose: "#f43f5e",
        purple: "#a855f7",
      };
      return colorMap[match[1]] || "#6b7280";
    }
    return "#6b7280";
  };

  return (
    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat) => (
        <article
          key={stat.title}
          className="rounded-xl bg-white shadow-lg hover:shadow-xl transition-transform duration-200 hover:-translate-y-1"
          style={{ borderLeft: `8px solid ${getAccentColor(stat.accent)}` }}
        >
          <div className="p-6 flex flex-col justify-between">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                  {stat.title}
                </p>
                <p className="mt-2 text-4xl font-extrabold text-black">
                  {stat.value}
                </p>
              </div>
              <div className="h-12 w-12 flex items-center justify-center">
                {statIcons[stat.title] || (
                  <div className="h-6 w-6 rounded-md bg-gray-100"></div>
                )}
              </div>
            </div>
            <p className="mt-4 text-xs text-gray-400 italic">{stat.trend}</p>
          </div>
        </article>
      ))}
    </section>
  );
};

export default DashboardStatCards;
